import { Text, Primary, TextLink } from '@cinch-labs/design-system'
import styles from './gap-opt-out-button.module.css'
import { useState } from 'react'
import { submitGapOptOutRequest } from './gap-opt-out-service'
import { GapOptOutResult } from './gap-opt-out-result'

export const GapOptOutButton: React.FC = () => {
  const [screenState, setScreenState] = useState<
    | 'SHOW_BUTTON'
    | 'SUCCESS'
    | 'ALREADY_UNSUBSCRIBED'
    | 'PASSED_WINDOW'
    | 'NO_ORDERID'
    | 'LOADING'
    | 'ERROR'
  >('SHOW_BUTTON')

  const onUnsubscribe = () => {
    setScreenState('LOADING')
    const querystring = new URLSearchParams(window.location.search)
    const orderId = querystring.get('orderId')

    if (orderId) {
      submitGapOptOutRequest({ orderId })
        .then((response) => {
          switch ((response.data as { message: string }).message) {
            case 'Order has opted out': {
              setScreenState('SUCCESS')
              break
            }
            case 'Order has already opted out': {
              setScreenState('ALREADY_UNSUBSCRIBED')
              break
            }
            default: {
              setScreenState('ERROR')
            }
          }
        })
        .catch((error) => {
          if (error?.response?.data?.message) {
            switch (error.response.data.message) {
              case 'Order is unable to opt out as it has passed the 24 hour opt out window': {
                setScreenState('PASSED_WINDOW')
                break
              }
              case 'Bad request - Order Id required':
              case 'Order has no related events': {
                setScreenState('NO_ORDERID')
                break
              }
              default: {
                setScreenState('ERROR')
                break
              }
            }
          } else {
            setScreenState('ERROR')
          }
        })
    } else {
      setScreenState('NO_ORDERID')
    }
  }

  const renderContent = () => {
    switch (screenState) {
      case 'SUCCESS': {
        return (
          <GapOptOutResult mainBody="You have successfully opted out from 30-day free GAP insurance." />
        )
      }
      case 'ALREADY_UNSUBSCRIBED': {
        return (
          <GapOptOutResult mainBody="You have already opted out from GAP Insurance." />
        )
      }
      case 'PASSED_WINDOW': {
        return (
          <GapOptOutResult mainBody="The 24-hour window to opt out from GAP insurance through cinch has already passed.">
            <Text fontSizeFixed={'l'} className={styles.secondaryBody}>
              You can still opt out via our partner Car Care Plan.
              <br />
              Look for an email from them or contact them directly by
              emailing&nbsp;
              <TextLink
                href="mailto:admin.team@motor-admin.com"
                textProps={{ className: styles.linkText }}
              >
                admin.team@motor-admin.com
              </TextLink>
            </Text>
          </GapOptOutResult>
        )
      }
      case 'NO_ORDERID': {
        return (
          <GapOptOutResult mainBody="Sorry, we can't find your order details. Please try again later." />
        )
      }
      case 'ERROR': {
        return (
          <GapOptOutResult mainBody="Sorry, we can't process your request right now. Please try again later." />
        )
      }
      default: {
        return (
          <>
            <Text fontSizeFixed={'l'}>
              Do you want to opt out of GAP Insurance?
            </Text>
            <Primary
              classNames={{ button: styles.button }}
              onClick={onUnsubscribe}
              isLoading={screenState === 'LOADING'}
            >
              Unsubscribe
            </Primary>
          </>
        )
      }
    }
  }

  return <div className={styles.mainBody}>{renderContent()}</div>
}
